import React, { useEffect, useState } from "react"
import { DateClass } from "../clases/DateClass"
import PrimaryButton from "../Components/Button/PrimaryButton"
import PrimaryTextField from "../Components/PrimaryTextField/PrimaryTextField"
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CancelIcon from '@mui/icons-material/Cancel';
import { Button } from '@mui/material';
import { useTranslation } from "react-i18next";
import DefaultModal from "./DefaultModal"
import { useEmail, useUser } from "../Hooks";
import { EmailPatvirtinimas } from "../Components/Emails/emails";

const UserModal = (props) => {
    const [info, setInfo] = useState(props.info || {})
    const [date, setDate] = useState(info?.validTo ? new DateClass(info.validTo) : new DateClass(new Date()))
    const [subscriptionType, setSubscriptionType] = useState('')
    const { t } = useTranslation()
    const [openModal, setOpenModal] = useState(false)
    const { sendEmail: sendMail } = useEmail();
    const { updateUser: update, DELETE: deleteUser } = useUser()
    // useEffect(() => { if (props.info) { setInfo(props.info) } }, [props.info])

    useEffect(() => {
        // Nustatome pradinį prenumeratos tipą pagal esamą validTo reikšmę
        if (!info.validTo) {
            setSubscriptionType('unlimited')
        } else {
            const validToDate = new Date(info.validTo)
            
            // Check if it's unlimited (year 3000)
            if (validToDate.getFullYear() === 3000) {
                setSubscriptionType('unlimited')
            } else {
                const oneYearFromNow = new Date()
                oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1)
                
                // Patikriname ar data yra lygiai vieneri metai nuo šiandien (±1 diena)
                const diffInDays = Math.abs((validToDate - oneYearFromNow) / (1000 * 60 * 60 * 24))
                if (diffInDays <= 1) {
                    setSubscriptionType('one_year')
                } else {
                    setSubscriptionType('custom')
                }
            }
        }
    }, [info.validTo])

    return (

        <div style={{ padding: '24px', backgroundColor: '#f5f5f5', borderRadius: '8px' }}>
            <div style={{ marginBottom: '20px' }}>
                <h3 style={{ fontSize: '20px', fontWeight: 600, marginBottom: '12px', color: '#333' }}>
                    {info.VP || info.imonesPavadinimas}
                </h3>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <a href={'tel: ' + info.tel} style={{ color: '#1976d2', textDecoration: 'none', fontSize: '14px' }}>
                        📞 {info.tel}
                    </a>
                    <a href={'mailto: ' + info.email} style={{ color: '#1976d2', textDecoration: 'none', fontSize: '14px' }}>
                        ✉️ {info.email}
                    </a>
                </div>
                
                {/* Paskyros statusas - profesionalesnis dizainas */}
                {!info.confirmed ? (
                    <div style={{ 
                        marginTop: '20px', 
                        padding: '16px', 
                        borderRadius: '12px', 
                        backgroundColor: '#fff8e1',
                        border: '2px solid #ffc107',
                        textAlign: 'center'
                    }}>
                        <div style={{ fontSize: '24px', marginBottom: '8px' }}>⚠️</div>
                        <p style={{ margin: 0, fontWeight: 600, color: '#f57c00', fontSize: '16px' }}>
                            {t('laukia_patvirtinimo') || 'Laukia patvirtinimo'}
                        </p>
                        <p style={{ margin: '8px 0 0 0', fontSize: '14px', color: '#616161' }}>
                            {t('paspauskite_patvirtinti_kad_aktyvuoti') || 'Paspauskite "Patvirtinti įmonę" mygtuką apačioje'}
                        </p>
                    </div>
                ) : (
                    <>
                        {/* Rodyti prenumeratos statusą tik patvirtintoms įmonėms */}
                        <div style={{ 
                            marginTop: '20px', 
                            padding: '16px', 
                            borderRadius: '12px', 
                            backgroundColor: new Date(info.validTo) >= new Date() ? '#e8f5e9' : '#ffebee',
                            border: `2px solid ${new Date(info.validTo) >= new Date() ? '#4caf50' : '#f44336'}`
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <div>
                                    <p style={{ 
                                        margin: 0, 
                                        fontWeight: 600, 
                                        color: new Date(info.validTo) >= new Date() ? '#2e7d32' : '#c62828',
                                        fontSize: '16px'
                                    }}>
                                        {new Date(info.validTo) >= new Date() ? '✅ Aktyvi prenumerata' : '❌ Pasibaigusi prenumerata'}
                                    </p>
                                    {new Date(info.validTo).getFullYear() !== 3000 && (
                                        <p style={{ margin: '4px 0 0 0', fontSize: '14px', color: '#616161' }}>
                                            {t('galioja_iki')}: <strong>{new Date(info.validTo).toLocaleDateString()}</strong>
                                        </p>
                                    )}
                                </div>
                                {new Date(info.validTo).getFullYear() === 3000 && (
                                    <span style={{ 
                                        backgroundColor: '#1976d2', 
                                        color: 'white', 
                                        padding: '4px 12px', 
                                        borderRadius: '16px',
                                        fontSize: '14px',
                                        fontWeight: 500
                                    }}>
                                        {t('neribota') || 'Neribota'}
                                    </span>
                                )}
                            </div>
                        </div>
                    </>
                )}
            </div>
            <div style={{ marginTop: '20px' }}>
                {/* Rodyti prenumeratos valdymą tik patvirtintoms įmonėms */}
                {info.confirmed && (
                    <div style={{ width: '100%', marginBottom: '20px' }}>
                        <h4 style={{ marginBottom: '10px', fontSize: '16px', fontWeight: 600 }}>
                            {t('prenumeratos_valdymas') || 'Prenumeratos valdymas'}
                        </h4>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                            <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                                <Button
                                    variant={subscriptionType === 'one_year' ? 'contained' : 'outlined'}
                                    onClick={() => {
                                        const nextYear = new Date();
                                        nextYear.setFullYear(nextYear.getFullYear() + 1);
                                        setInfo((prevState) => ({ ...prevState, validTo: nextYear }))
                                        setDate(new DateClass(nextYear))
                                        setSubscriptionType('one_year')
                                    }}
                                    sx={{
                                        textTransform: 'none',
                                        borderRadius: '8px',
                                        padding: '8px 20px',
                                        fontSize: '14px',
                                        minWidth: '140px'
                                    }}
                                >
                                    {t('vieneri_metai') || 'Vieneri metai'}
                                </Button>
                                <Button
                                    variant={subscriptionType === 'unlimited' ? 'contained' : 'outlined'}
                                    onClick={() => {
                                        const unlimitedDate = new Date();
                                        unlimitedDate.setFullYear(3000);
                                        setInfo((prevState) => ({ ...prevState, validTo: unlimitedDate }))
                                        setDate(new DateClass(unlimitedDate))
                                        setSubscriptionType('unlimited')
                                    }}
                                    sx={{
                                        textTransform: 'none',
                                        borderRadius: '8px',
                                        padding: '8px 20px',
                                        fontSize: '14px',
                                        minWidth: '140px'
                                    }}
                                >
                                    {t('neribotai') || 'Neribotai'}
                                </Button>
                                <Button
                                    variant={subscriptionType === 'custom' ? 'contained' : 'outlined'}
                                    onClick={() => {
                                        setSubscriptionType('custom')
                                    }}
                                    sx={{
                                        textTransform: 'none',
                                        borderRadius: '8px',
                                        padding: '8px 20px',
                                        fontSize: '14px',
                                        minWidth: '140px'
                                    }}
                                >
                                    {t('pasirinkti_data') || 'Pasirinkti datą'}
                                </Button>
                            </div>
                            {subscriptionType === 'custom' && (
                                <div style={{ marginTop: '12px' }}>
                                    <label 
                                        htmlFor="user-valid-to-date"
                                        style={{ 
                                            display: 'block', 
                                            marginBottom: '8px', 
                                            fontSize: '14px', 
                                            fontWeight: 500,
                                            color: '#333'
                                        }}
                                    >
                                        {t('galioja_iki') || 'Galioja iki'}
                                    </label>
                                    <input
                                        id="user-valid-to-date"
                                        name="validTo"
                                        type="date"
                                        value={info.validTo ? new Date(info.validTo).toISOString().split('T')[0] : ''}
                                        min={new Date().toISOString().split('T')[0]}
                                        onChange={(e) => {
                                            const newValue = new Date(e.target.value);
                                            setInfo((prevState) => ({ ...prevState, validTo: newValue }))
                                            setDate(new DateClass(newValue))
                                        }}
                                        style={{
                                            width: '100%',
                                            padding: '12px',
                                            border: '1px solid #ccc',
                                            borderRadius: '4px',
                                            fontSize: '14px',
                                            backgroundColor: 'white'
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                )}
                
                <div style={{ display: 'flex', flexDirection: 'row', gap: '12px', marginTop: '24px' }}>
                    {!info.confirmed ? (
                        <PrimaryButton
                            text={t('patvirtinti_imone') || 'Patvirtinti įmonę'}
                            startIcon={<ArrowForwardIcon />}
                            onClick={async () => {
                                try {
                                    // Nustatome galiojimą iki kitų metų
                                    const nextYear = new Date();
                                    nextYear.setFullYear(nextYear.getFullYear() + 1);
                                    
                                    // Atnaujinkite informaciją
                                    const updatedInfo = {
                                        ...info,
                                        confirmed: true,
                                        validTo: nextYear
                                    };
                                    
                                    // Siųskite el. laišką
                                    await sendMail(EmailPatvirtinimas(info.email, t));
                                    
                                    // Išsaugome pakeitimus
                                    await update(info.id, updatedInfo, setInfo);
                                    setInfo(updatedInfo);
                                    props.r(); // Atnaujinamas sąrašas
                                    
                                    alert(t('Įmonė sėkmingai patvirtinta!') || 'Įmonė patvirtinta ir prenumerata aktyvuota vieniems metams!');
                                } catch (error) {
                                    alert(t('klaida') || 'Įvyko klaida patvirtinant įmonę');
                                }
                            }}
                            variant="contained"
                            size="large"
                            sx={{
                                flex: 1,
                                height: '48px',
                                backgroundColor: '#4caf50',
                                '&:hover': {
                                    backgroundColor: '#45a049'
                                }
                            }}
                        />
                    ) : (
                        <PrimaryButton
                            text={t('issaugoti') || 'Išsaugoti pakeitimus'}
                            onClick={async () => {
                                try {
                                    // Išsaugome pakeitimus
                                    await update(info.id, info, setInfo);
                                    props.r(); // Atnaujinamas sąrašas
                                    alert(t('pakeitimai_issaugoti') || 'Pakeitimai išsaugoti!');
                                } catch (error) {
                                    alert(t('klaida') || 'Įvyko klaida išsaugant pakeitimus');
                                }
                            }}
                            variant="contained"
                            size="large"
                            sx={{
                                flex: 1,
                                height: '48px',
                                backgroundColor: '#1976d2',
                                '&:hover': {
                                    backgroundColor: '#1565c0'
                                }
                            }}
                        />
                    )}
                </div>
            </div>
            <div style={{ marginTop: '40px', paddingTop: '20px', borderTop: '1px solid #e0e0e0' }}>
                <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                    {info.confirmed && (
                        <PrimaryButton
                            text={t('deaktyvuoti') || 'Deaktyvuoti'}
                            variant='outlined'
                            onClick={async () => {
                                try {
                                    const updatedInfo = {
                                        ...info,
                                        confirmed: false,
                                        validTo: null
                                    };
                                    
                                    await update(updatedInfo);
                                    setInfo(updatedInfo);
                                    props.r(); // Refresh parent component
                                } catch (error) {
                                    console.error('Error deactivating company:', error);
                                }
                            }}
                            size="small"
                            sx={{
                                borderColor: '#ff9800',
                                color: '#ff9800',
                                '&:hover': {
                                    borderColor: '#f57c00',
                                    backgroundColor: 'rgba(255, 152, 0, 0.04)',
                                    color: '#f57c00'
                                }
                            }}
                        />
                    )}
                    <PrimaryButton
                        text={t('trinti') || 'Ištrinti įmonę'}
                        variant='text'
                        endIcon={<CancelIcon />}
                        onClick={() => {
                            setOpenModal(true)
                        }}
                        size="small"
                        sx={{
                            color: '#d32f2f',
                            '&:hover': {
                                backgroundColor: 'rgba(211, 47, 47, 0.04)',
                                color: '#c62828'
                            }
                        }}
                    />
                </div>
            </div>
            <DefaultModal
                modal={openModal}
                setModal={setOpenModal}
                element={
                    <div className="centerContainer1">
                        <p className="modalTxt">{t('arIstrintProfili')}</p>
                        <div className="row modalBtnCont">
                            <PrimaryButton
                                text='taip'
                                className='margin modalBtn'
                                onClick={async () => {
                                    let isDeleted = await deleteUser(info.id, info.imonesPavadinimas)
                                    if (isDeleted) {
                                        props.r()
                                        setOpenModal(false)
                                    }
                                }}
                            />
                            <PrimaryButton
                                text='ne'
                                className='margin modalBtn'

                                onClick={() => {
                                    setOpenModal(false)
                                }}
                            />

                        </div>
                    </div>
                }
            />
        </div>
    )
}
export default UserModal
